module.exports = __webpack_public_path__ + "img/img1.b1c7a648.png";